import React from "react";
import { ArrowUpCircle, ArrowDownCircle, DollarSign } from "lucide-react";

const LedgerSummary = ({ summary }) => {
  const formatCurrency = amount => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mt-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        Ledger Summary
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-gray-50 rounded-lg p-4">
          <div className="flex items-center mb-2">
            <ArrowUpCircle className="text-red-500 mr-2" size={20} />
            <span className="text-gray-600 text-sm">Total Debit</span>
          </div>
          <div className="text-xl font-semibold text-gray-800">
            {formatCurrency(summary.totalDebit)}
          </div>
        </div>

        <div className="bg-gray-50 rounded-lg p-4">
          <div className="flex items-center mb-2">
            <ArrowDownCircle className="text-green-500 mr-2" size={20} />
            <span className="text-gray-600 text-sm">Total Credit</span>
          </div>
          <div className="text-xl font-semibold text-gray-800">
            {formatCurrency(summary.totalCredit)}
          </div>
        </div>

        <div className="bg-purple-50 rounded-lg p-4">
          <div className="flex items-center mb-2">
            <DollarSign className="text-purple-500 mr-2" size={20} />
            <span className="text-gray-600 text-sm">Closing Balance</span>
          </div>
          <div className="text-xl font-semibold text-gray-800">
            {formatCurrency(summary.closingBalance)}{" "}
            {summary.closingBalanceType}
          </div>
        </div>
      </div>

      <div className="border-t border-gray-200 mt-6 pt-6">
        <div className="flex justify-between items-center text-sm text-gray-500">
          <span>
            Transactions:{" "}
            {summary.totalDebit > 0 && summary.totalCredit > 0
              ? `Showing ${summary.totalDebit > 0 ? "debits" : ""} ${
                  summary.totalDebit > 0 && summary.totalCredit > 0 ? "and" : ""
                } ${summary.totalCredit > 0 ? "credits" : ""}`
              : "No transactions in this period"}
          </span>
          <span>
            Balance Status:{" "}
            <span
              className={
                summary.closingBalanceType === "Dr"
                  ? "text-red-500"
                  : "text-green-500"
              }>
              {summary.closingBalanceType === "Dr" ? "Receivable" : "Payable"}
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default LedgerSummary;
